import { get } from '@barbanet/api-service'

import { UserPermissionsResponse } from '../types/dto/permission'

export const userPermissionsService = () =>
	get<UserPermissionsResponse>('uaa', 'users/permissions')
